import { MENU_ITEM_CLASSES, MENU_SEPARATOR_CLASSES } from "@controls";
import { ChevronLeft } from "@icons";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import classNames from "classnames";

export default function BackButton({
  label,
  onBack,
}: {
  label: string | JSX.Element;
  onBack: () => void;
}) {
  return (
    <>
      <DropdownMenu.Item
        onSelect={(e) => {
          e.preventDefault();
          onBack();
        }}
        className={classNames(MENU_ITEM_CLASSES, "gap-2 font-medium")}
      >
        <span className="w-4 h-4 shrink-0 grid place-items-center text-gray-500 transition-colors duration-100 group-data-[highlighted]:text-primary-500">
          <ChevronLeft size={16} />
        </span>
        <span className="flex-1 min-w-0 truncate">{label}</span>
      </DropdownMenu.Item>
      <DropdownMenu.Separator className={MENU_SEPARATOR_CLASSES} />
    </>
  );
}
